export default __webpack_public_path__ + "static/mongo-e3d303c414914d83effb6973cb200895.png";